// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@imgs/register/new-theme/head-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@imgs/register/red-theme/logo-big.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@imgs/activity/check.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes skin6_rotate__12b8U {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.skin6_skin6__MzRJG {
  height: 100%;
  background-color: #f5f6f9;
}
.skin6_skin6__MzRJG .skin6_header__97OBl {
  padding: 8vw 4.266667vw 0;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 56vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz {
  font-size: 5.333333vw;
  font-weight: 600;
  line-height: 5.333333vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz .skin6_logo__fBf0X {
  margin-right: 2.666667vw;
  width: 11.2vw;
  height: 11.2vw;
  background-size: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz .skin6_logoBoxRight__wt0MM {
  display: flex;
  flex-direction: column;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz .skin6_logoBoxRight__wt0MM .skin6_logoText__e8uwb {
  width: 21.333333vw;
  height: 5.6vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz .skin6_logoBoxRight__wt0MM .skin6_youqianLogoText__Mhwpv {
  height: 5.6vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz .skin6_logoBoxRight__wt0MM .skin6_logoText2__bTNBa {
  margin-top: 1.066667vw;
  width: 21.066667vw;
  height: 2.933333vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_logoBox__SfXgz .skin6_logoBoxRight__wt0MM .skin6_logoText3__wEWQb {
  margin-top: 1px;
  font-size: 3.2vw;
  color: #fff;
  font-weight: 600;
  transform: scale(0.86) translateX(-2.666667vw);
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_headTitps__4Lv0e {
  margin: 2.666667vw auto 5.333333vw;
  width: 64.8vw;
  height: 5.866667vw;
  transform: translateX(-1.333333vw);
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_headTitps__4Lv0e img {
  width: 100%;
  height: 100%;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK {
  width: 91.466667vw;
  background: linear-gradient(180deg, #FBE5D7 0%, #FFFFFF 27.54%);
  border-radius: 2.133333vw;
  padding-bottom: 6.666667vw;
  padding: 6.4vw 0;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_limitTitle__Yh2gm {
  font-size: 3.733333vw;
  color: #262626;
  text-align: center;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_limitNum__FKb9g {
  margin: 2.666667vw 0;
  font-size: 12.8vw;
  line-height: 12.8vw;
  color: #262626;
  text-align: center;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_limitTips__RJPqE {
  font-size: 3.2vw;
  color: #8C8C8C;
  text-align: center;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP {
  margin-top: 6.4vw;
  box-sizing: border-box;
  padding: 0 3.2vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_phoneBox__hCcAQ {
  height: 12.266667vw;
  background: #f4f5f7;
  border-radius: 2.133333vw;
  display: flex;
  align-items: center;
  margin: 2.4vw auto 0;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_phoneBox__hCcAQ .skin6_label__s91jE {
  width: 45.333333vw;
  text-align: center;
  font-size: 4.266667vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_phoneBox__hCcAQ .adm-input-element {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_phoneBox__hCcAQ .adm-input-element::placeholder {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_getCms__qPj46 {
  margin-top: 3.2vw;
  height: 12.8vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #ffcfa0 1%, #e19459);
  border-radius: 1.6vw;
  color: #FFFFFF;
  font-size: 4.266667vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy .skin6_primary__tQLAr {
  color: #DE9960;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy {
  margin: 6.4vw auto;
  font-size: 3.2vw;
  color: #8C8C8C;
  line-height: 3.2vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy.skin6_animation__pbHLq {
  position: relative;
  animation: skin6_shake__uSP0f 0.1s;
}
@keyframes skin6_shake__uSP0f {
  0% {
    left: 2.133333vw;
  }
  50% {
    left: -2.133333vw;
  }
  100% {
    left: 0;
  }
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy .skin6_checked__\\+oIjf {
  margin-right: 1.6vw;
  border: 1px solid #D9D9D9;
  border-radius: 100%;
  width: 3.733333vw;
  height: 3.733333vw;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy .skin6_checked__\\+oIjf.skin6_active__6J3kc {
  position: relative;
  border: none;
  background: #DE9960;
}
.skin6_skin6__MzRJG .skin6_header__97OBl .skin6_main__4c5AK .skin6_formBox__YVzbP .skin6_agreement__lJxcy .skin6_checked__\\+oIjf.skin6_active__6J3kc::before {
  position: absolute;
  top: 1.066667vw;
  left: 0.533333vw;
  width: 2.4vw;
  height: 1.6vw;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100%;
}
.skin6_skin6__MzRJG .skin6_footerBar__iWiSm {
  margin: 5.333333vw auto;
  padding: 6.4vw 4.266667vw;
  width: 91.466667vw;
  background-color: #fff;
  border-radius: 2.133333vw;
  box-sizing: border-box;
}
.skin6_skin6__MzRJG .skin6_footerBar__iWiSm .skin6_footerBarImg__5oYVH {
  width: 64.8vw;
  height: 12.533333vw;
  display: block;
  margin: 0 auto;
}
.skin6_skin6__MzRJG .skin6_footerBar__iWiSm .skin6_steps__4\\+bjh {
  margin-top: 6.4vw;
  padding: 0 3.2vw;
  display: flex;
  justify-content: space-between;
}
.skin6_skin6__MzRJG .skin6_footerBar__iWiSm .skin6_steps__4\\+bjh .skin6_stepItem__wqvdR .skin6_stepNum__jlznr {
  width: 7.466667vw;
  height: 7.466667vw;
  margin: 0 auto;
  background-color: #ff5161;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.skin6_skin6__MzRJG .skin6_footerBar__iWiSm .skin6_steps__4\\+bjh .skin6_stepItem__wqvdR .skin6_stepName__5xq3T {
  margin-top: 2.133333vw;
  font-size: 3.2vw;
  color: #262626;
}
.skin6_skin6__MzRJG .skin6_footerBar__iWiSm .skin6_steps__4\\+bjh .skin6_splitLine__nhQRG {
  width: 12.8vw;
  height: 1px;
  background-color: #EAEAEA;
  margin: 4vw 2.133333vw;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign {
  width: 93.866667vw;
  height: 121.333333vw;
  margin: 2.933333vw auto;
  background: #fff;
  border-radius: 2.133333vw;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_title__CTVe4 {
  width: 100%;
  height: 10.133333vw;
  background: linear-gradient(180deg, #FDF2E5 0%, #FBE4CE 100%);
  border-radius: 1.6vw 1.6vw 0px 0px;
  text-align: center;
  line-height: 10.133333vw;
  font-weight: 400;
  font-size: 3.2vw;
  color: #DE9960;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign h3 {
  font-weight: 600;
  font-size: 4.266667vw;
  color: #333;
  padding: 3.2vw 4.266667vw 1.6vw;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign h3 span {
  font-size: 3.2vw;
  color: #BB6C1D;
  font-weight: normal;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 4.266667vw;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY .skin6_loanTermItem__tN58f {
  margin-top: 2.133333vw;
  width: 41.066667vw;
  height: 16vw;
  padding-bottom: 1.6vw;
  background-color: #f3f4f6;
  text-align: center;
  border-radius: 1.066667vw;
  font-size: 4vw;
  box-sizing: border-box;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY .skin6_loanTermItem__tN58f p {
  margin-top: 1.6vw;
  color: #8C8C8C;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY .skin6_loanTermItem__tN58f p.skin6_samllText__PLtkC {
  font-size: 3.2vw;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY .skin6_loanTermItem__tN58f.skin6_active__6J3kc {
  background-color: #fff9f4;
  border: 1Px solid #bb9674;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY .skin6_loanTermItem__tN58f.skin6_active__6J3kc p {
  color: #bb9674;
}
.skin6_skin6__MzRJG .skin6_checkBox__v2ign .skin6_loanTermList__xLvmY .skin6_loanTermItem__tN58f.skin6_is360Channel__\\+9IgH {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.266667vw;
}
.skin6_skin6__MzRJG .skin6_tipBox__1D7xG {
  padding-bottom: 13.333333vw;
}
.skin6_skin6__MzRJG .skin6_tipBox__1D7xG .skin6_tip__ROddc {
  font-size: 3.2vw;
  line-height: 5.333333vw;
  text-align: center;
  color: #8C8C8C;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: none;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD.skin6_showPopup__cboCg {
  display: block;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD .skin6_dialogMain__AL7X9 {
  width: 85.333333vw;
  height: 48vw;
  border-radius: 2.133333vw;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 5.333333vw 0;
  box-sizing: border-box;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD .skin6_dialogMain__AL7X9 .skin6_close__cn4hA {
  width: 100%;
  font-size: 5.333333vw;
  text-align: right;
  margin-right: 5.333333vw;
  color: rgb(214, 217, 223);
  padding-right: 5.333333vw;
  box-sizing: border-box;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD .skin6_dialogMain__AL7X9 .skin6_inputBox__OE2ia {
  width: 76vw;
  height: 12.8vw;
  border: 1px solid #e19459;
  margin: 2.666667vw auto;
  padding-left: 5.333333vw;
  border-radius: 2.133333vw;
  display: flex;
  align-items: center;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD .skin6_dialogMain__AL7X9 .skin6_inputBox__OE2ia .skin6_code__2YfOr {
  width: 40vw;
  text-align: center;
  color: #e19459;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD .skin6_dialogMain__AL7X9 .skin6_inputBox__OE2ia .adm-input-element {
  font-size: 4vw;
  line-height: 8vw;
}
.skin6_skin6__MzRJG .skin6_dialogOverlay__uUFzD .skin6_dialogMain__AL7X9 .skin6_limit__y5QX7 {
  margin: 4.8vw auto;
  width: 75.466667vw;
  height: 11.733333vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #ffcfa0 1%, #e19459);
  border-radius: 1.6vw;
  color: #FFFFFF;
  font-size: 4.266667vw;
}

.adm-auto-center .adm-auto-center-content {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/mixin.scss","webpack://./src/pages/register/components/skin6/skin6.module.scss","webpack://./src/styles/var.scss"],"names":[],"mappings":"AA4KA;EACE;IACE,uBAAA;EC3KF;ED8KA;IACE,yBAAA;EC5KF;AACF;AAJA;EACE,YAAA;EACA,yBAAA;AAMF;AAJE;EACE,yBAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;EACA,yDAAA;AAMJ;AAJI;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;ED2OJ,aAAA;EAGE,uBAAA;EAIA,mBAAA;ACzOJ;AALM;EACE,wBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yDAAA;AAOR;AAJM;EACE,aAAA;EACA,sBAAA;AAMR;AALQ;EACE,kBAAA;EACA,aAAA;AAOV;AALQ;EAEE,aAAA;AAMV;AAJQ;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;AAMV;AAJQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,8CAAA;AAMV;AADI;EACE,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,kCAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;AAIR;AAAI;EACE,kBAAA;EACA,+DAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;AAEN;AADM;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;AAGR;AADM;EACE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAGR;AADM;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AAGR;AADM;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;AAGR;AAFQ;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAIV;AAHU;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AAKZ;AAFY;EACE,qBAAA;EAEA,gBAAA;AAGd;AAFc;EACE,qBAAA;EACA,gBAAA;AAIhB;AACQ;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AACV;AACQ;ED4HN,aAAA;EAGE,uBAAA;EAIA,mBAAA;ECjIM,eAAA;AAGV;AADU;EACE,cAAA;AAGZ;AARQ;EAQE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAGV;AADU;EACE,kBAAA;EACA,kCAAA;AAGZ;AAAU;EACE;IACE,gBAAA;EAEZ;EACU;IACE,iBAAA;EACZ;EAEU;IACE,OAAA;EAAZ;AACF;AAGU;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADZ;AAIY;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;AAFd;AAIc;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,qBAAA;AAFhB;AAWE;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AATJ;AAUI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AARN;AAUI;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AARN;AAUQ;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARV;AAUQ;EACE,sBAAA;EACA,gBAAA;EACA,cAAA;AARV;AAWM;EACE,aAAA;EACA,WAAA;EACA,yBAAA;EAEA,sBAAA;AAVR;AAeE;EACE,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AAbJ;AAcI;EACE,WAAA;EACA,mBAAA;EACA,6DAAA;EACA,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAZN;AAcI;EACE,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,+BAAA;AAZN;AAaM;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AAXR;AAcI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;AAZN;AAaM;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;AAXR;AAYQ;EACE,iBAAA;EACA,cAAA;AAVV;AAWU;EACE,gBAAA;AATZ;AAYQ;EACE,yBAAA;EACA,yBAAA;AAVV;AAWU;EACE,cAAA;AATZ;AAYQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAVV;AAgBE;EACE,2BAAA;AAdJ;AAeI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cC9RY;ADiRlB;AAiBE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AAfJ;AAgBI;EACE,cAAA;AAdN;AAgBI;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AAdN;AAeM;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAbR;AAeM;EACE,WAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAbR;AAcQ;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AAZV;AAeU;EACE,cAAA;EAEA,gBAAA;AAdZ;AAkBM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AAhBR;;AAwBI;EACE,6BAAA;AArBN","sourcesContent":["@charset \"UTF-8\";\n\n// 圆圈\n@mixin circle($width) {\n  display: inline-block;\n  border-radius: 50%;\n  width: $width;\n  height: $width;\n}\n\n// 省略号样式\n@mixin ellipsis($lineNum: \"\") {\n  overflow: hidden;\n\n  @if $lineNum != \"\" {\n    /* stylelint-disable-next-line */\n    display: -webkit-box;\n    /* stylelint-disable-next-line */\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: $lineNum;\n  } @else {\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// css箭头\n@mixin arrow($direction, $width, $height, $color) {\n  display: inline-block;\n  width: 0;\n  height: 0;\n\n  @if $direction == \"top\" {\n    border-top: 0;\n    border-right: solid $width transparent;\n    border-bottom: solid $height $color;\n    border-left: solid $width transparent;\n  } @else if $direction == \"bottom\" {\n    border-top: solid $height $color;\n    border-right: solid $width transparent;\n    border-bottom: 0;\n    border-left: solid $width transparent;\n  } @else if $direction == \"left\" {\n    border-top: solid $height transparent;\n    border-right: solid $width $color;\n    border-bottom: solid $height transparent;\n    border-left: 0;\n  } @else if $direction == \"right\" {\n    border-top: solid $height transparent;\n    border-right: 0;\n    border-bottom: solid $height transparent;\n    border-left: solid $width $color;\n  }\n}\n\n// 上下左右居中，为解决被外部数据覆盖的问题，强制使用!important\n@mixin setXYMiddle($width, $height) {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  margin-top: -$height / 2 !important;\n  margin-left: -$width / 2 !important;\n  width: $width !important;\n  min-width: unset;\n  height: $height !important;\n}\n\n// 上下居中\n@mixin setYMiddle($height) {\n  position: absolute;\n  top: 50%;\n  margin-top: -$height / 2;\n  height: $height;\n}\n\n// 左右居中\n@mixin setXMiddle($width) {\n  position: absolute;\n  left: 50%;\n  margin-left: -$width / 2;\n  width: $width;\n}\n\n// 切换动画\n@mixin transition($type) {\n  transition: .3s $type;\n}\n\n// 按钮公共样式\n@mixin btn-normal($color) {\n  @include transition(background-color);\n\n  border-color: $color;\n  border-radius: 20px;\n  width: 90px;\n  height: 40px;\n  font-size: $font-size-14;\n  text-align: center;\n  color: $color-FFFFFF;\n  background: $color;\n  line-height: 40px;\n  cursor: pointer;\n  user-select: none;\n}\n\n// 失效状态，强制使用同一种颜色\n@mixin disable($type, $color) {\n  cursor: not-allowed !important;\n\n  @if $type == \"color\" {\n    color: $color !important;\n\n    &:hover {\n      color: $color !important;\n    }\n\n    &:active {\n      color: $color !important;\n    }\n  } @else if $type == \"background-color\" {\n    background-color: $color !important;\n\n    &:hover {\n      background-color: $color !important;\n    }\n\n    &:active {\n      background-color: $color !important;\n    }\n  }\n}\n\n// 全局阴影效果\n@mixin shadow {\n  box-shadow: 0 0 10px 2px rgba(#5E5C5C, .25);\n}\n\n// 变色样式\n@mixin action-green($type) {\n  @include transition($type);\n\n  cursor: pointer;\n\n  @if $type == \"color\" {\n    &:hover {\n      color: $color-55DE99 !important;\n    }\n\n    &:active {\n      color: $color-22B76B !important;\n    }\n  } @else if $type == \"background-color\" {\n    &:hover {\n      background-color: $color-55DE99 !important;\n    }\n\n    &:active {\n      background-color: $color-22B76B !important;\n    }\n  }\n}\n\n// 清除浮动\n@mixin clearfix {\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// 旋转\n@mixin animation-rotate() {\n  animation-duration: 1s;\n  animation-name: rotate;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(1, 1, 1, 1);\n}\n\n// 文本n行溢出隐藏显示...\n@mixin ellipsis-basic($n) {\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: $n;\n  -webkit-line: $n;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n// 文本不换行\n@mixin no-wrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// 宽高\n@mixin wh($w: 100%, $h: 100%) {\n  width: $w;\n  height: $h;\n}\n\n// 跳转文字 有hover效果\n@mixin link($color: $text-grey-color, $hover-color: $text-grey-color) {\n  position: relative;\n  color: $color;\n  cursor: pointer;\n  user-select: none;\n\n  @content;\n\n  &:hover {\n    color: $hover-color;\n  }\n}\n\n// 跳转文字 带下划线 有hover效果\n@mixin link-underline($color: $text-grey-color, $hover-color: $text-grey-color) {\n  @include link($color, $hover-color) {\n    &:hover {\n      &::after {\n        border-bottom-color: $hover-color;\n      }\n    }\n\n    &::after {\n      position: absolute;\n      bottom: 0;\n      content: \"\";\n      left: 0;\n      border-bottom: 1px solid $color;\n      width: 100%;\n    }\n  }\n}\n\n// flex 布局\n@mixin flex($obj) {\n  display: flex;\n\n  @if map-get($obj, \"justify\") {\n    justify-content: map-get($obj, \"justify\");\n  }\n\n  @if map-get($obj, \"align\") {\n    align-items: map-get($obj, \"align\");\n  }\n}\n\n// flex 水平居中\n@mixin flex-c {\n  @include flex((justify: center));\n}\n\n// flex 垂直居中\n@mixin flex-vc {\n  @include flex((align: center));\n}\n\n// flex 水平两端对齐\n@mixin flex-sb {\n  @include flex((justify: space-between));\n}\n\n// flex 水平垂直居中\n@mixin flex-cc {\n  @include flex((justify: center, align: center));\n}\n\n// flex 水平两端对齐，垂直居中\n@mixin flex-sbc {\n  @include flex((justify: space-between, align: center));\n}","@import \"@/styles/var.scss\";\n@import \"@/styles/mixin.scss\";\n\n.skin6 {\n  height: 100%;\n  background-color: #f5f6f9;\n\n  .header {\n    padding: 30px 16px 0;\n    width: 100%;\n    background-repeat: no-repeat;\n    background-size: 100% 210px;\n    background-image: url(\"~@imgs/register/new-theme/head-bg.png\");\n\n    .logoBox {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 20px;\n\n      @include flex-cc;\n\n      .logo {\n        margin-right: 10px;\n        width: 42px;\n        height: 42px;\n        background-size: 100%;\n        background-image: url(\"~@imgs/register/red-theme/logo-big.png\");\n      }\n\n      .logoBoxRight {\n        display: flex;\n        flex-direction: column;\n        .logoText {\n          width: 80px;\n          height: 21px\n        }\n        .youqianLogoText {\n          //width: 54px;\n          height: 21px\n        }\n        .logoText2 {\n          margin-top: 4px;\n          width: 79px;\n          height: 11px\n        }\n        .logoText3 {\n          margin-top: 1px;\n          font-size: 12px;\n          color: #fff;\n          font-weight: 600;\n          transform: scale(.86) translateX(-10px);\n        }\n      }\n    }\n\n    .headTitps {\n      margin: 10px auto 20px;\n      width: 243px;\n      height: 22px;\n      transform: translateX(-5px);\n      img {\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    .main {\n      width: 343px;\n      background: linear-gradient(180deg, #FBE5D7 0%, #FFFFFF 27.54%);\n      border-radius: 8px;\n      padding-bottom: 25px;\n      padding: 24px 0;\n      .limitTitle {\n        font-size: 14px;\n        color: #262626;\n        text-align: center;\n      }\n      .limitNum {\n        margin: 10px 0;\n        font-size: 48px;\n        line-height: 48px;\n        color: #262626;\n        text-align: center;\n      }\n      .limitTips {\n        font-size: 12px;\n        color: #8C8C8C;\n        text-align: center;\n      }\n      .formBox {\n        margin-top: 24px;\n        box-sizing: border-box;\n        padding: 0 12px;\n        .phoneBox {\n          height: 46px;\n          background: #f4f5f7;\n          border-radius: 8px;\n          display: flex;\n          align-items: center;\n          margin: 9px auto 0;\n          .label {\n            width: 170px;\n            text-align: center;\n            font-size: 16px;\n          }\n          :global {\n            .adm-input-element {\n              font-size: 16px;\n              // font-weight: 600;\n              line-height: 30px;\n              &::placeholder {\n                font-size: 16px;\n                line-height: 30px;\n              }\n            }\n          }\n        }\n        .getCms {\n          margin-top: 12px;\n          height: 48px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background-image: linear-gradient(180deg,#ffcfa0 1%,#e19459);\n          border-radius: 6px;\n          color: #FFFFFF;\n          font-size: 16px;\n        }\n        .agreement {\n          @include flex-cc;\n          flex-wrap: wrap;\n  \n          .primary {\n            color: #DE9960;\n          }\n      \n          margin: 24px auto;\n          font-size: 12px;\n          color: #8C8C8C;\n          line-height: 12px;\n  \n          &.animation {\n            position: relative;\n            animation: shake .1s;\n          }\n  \n          @keyframes shake {\n            0% {\n              left: 8px;\n            }\n  \n            50% {\n              left: -8px;\n            }\n      \n            100% {\n              left: 0;\n            }\n          }\n      \n          .checked {\n            margin-right: 6px;\n            border: 1px solid #D9D9D9;\n            border-radius: 100%;\n            width: 14px;\n            height: 14px;\n            // background-color: #DE9960;\n      \n            &.active {\n              position: relative;\n              border: none;\n              background: #DE9960;\n      \n              &::before {\n                position: absolute;\n                top: 4px;\n                left: 2px;\n                width: 9px;\n                height: 6px;\n                content: \"\";\n                background-image: url(\"~@imgs/activity/check.png\");\n                background-size: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .footerBar {\n    margin: 20px auto;\n    padding: 24px 16px;\n    width: 343px;\n    background-color: #fff;\n    border-radius: 8px;\n    box-sizing: border-box;\n    .footerBarImg {\n      width: 243px;\n      height: 47px;\n      display: block;\n      margin: 0 auto;\n    }\n    .steps {\n      margin-top: 24px;\n      padding: 0 12px;\n      display: flex;\n      justify-content: space-between;\n      .stepItem {\n        .stepNum {\n          width: 28px;\n          height: 28px;\n          margin: 0 auto;\n          background-color: #ff5161;\n          border-radius: 50%;\n          color: #fff;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        .stepName {\n          margin-top: 8px;\n          font-size: 12px;\n          color: #262626;\n        }\n      }\n      .splitLine {\n        width: 48px;\n        height: 1px;\n        background-color: #EAEAEA;\n        // border: 1px solid #EAEAEA;\n        margin: 15px 8px;\n      }\n    }\n  }\n\n  .checkBox {\n    width: 352px;\n    height: 455px;\n    margin: 11px auto ;\n    background: #fff;\n    border-radius: 8px;\n    .title {\n      width: 100%;\n      height: 38px;\n      background: linear-gradient(180deg, #FDF2E5 0%, #FBE4CE 100%);\n      border-radius: 6px 6px 0px 0px;\n      text-align: center;\n      line-height: 38px;\n      font-weight: 400;\n      font-size: 12px;\n      color: #DE9960;\n    }\n    h3 {\n      font-weight: 600;\n      font-size: 16px;\n      color: #333;\n      padding: 12px 16px 6px;\n      span {\n        font-size: 12px;\n        color: #BB6C1D;\n        font-weight: normal;\n      }\n    }\n    .loanTermList {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      padding: 0 16px;\n      .loanTermItem {\n        margin-top: 8px;\n        width: 154px;\n        height: 60px;\n        padding-bottom: 6px;\n        background-color: #f3f4f6;\n        text-align: center;\n        border-radius: 4px;\n        font-size: 15px;\n        box-sizing: border-box;\n        p {\n          margin-top: 6px;\n          color: #8C8C8C;\n          &.samllText {\n            font-size: 12px;\n          }\n        }\n        &.active {\n          background-color: #fff9f4;\n          border: 1Px solid #bb9674;\n          p {\n            color: #bb9674;\n          }\n        }\n        &.is360Channel {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n        }\n      }\n    }\n  }\n\n  .tipBox {\n    padding-bottom: 50px;\n    .tip {\n      font-size: 12px;\n      line-height: 20px;\n      text-align: center;\n      color: $text-gray-color;\n    }\n  }\n\n  .dialogOverlay {\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(0,0,0,.7);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    display: none;\n    &.showPopup {\n      display: block;\n    }\n    .dialogMain {\n      width: 320px;\n      height: 180px;\n      border-radius: 8px;\n      background-color: #fff;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      padding: 20px 0;\n      box-sizing: border-box;\n      .close {\n        width: 100%;\n        font-size: 20px;\n        text-align: right;\n        margin-right: 20px;\n        color: rgb(214, 217, 223);\n        padding-right: 20px;\n        box-sizing: border-box;\n      }\n      .inputBox {\n        width: 285px;\n        height: 48px;\n        border: 1px solid #e19459;\n        margin: 10px auto;\n        padding-left: 20px;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        .code {\n          width: 150px;\n          text-align: center;\n          color: #e19459;\n        }\n        :global {\n          .adm-input-element {\n            font-size: 15px;\n            // font-weight: 600;\n            line-height: 30px;\n          }\n        }\n      }\n      .limit {\n        margin: 18px auto;\n        width: 283px;\n        height: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: linear-gradient(180deg,#ffcfa0 1%,#e19459);\n        border-radius: 6px;\n        color: #FFFFFF;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n:global {\n  .adm-auto-center {\n    .adm-auto-center-content {\n      text-align: center !important;\n    }\n  }\n}\n","// 公共颜色\n$color-primary: #FF4D4F;\n\n// 主字色\n$color-black: #262626;\n$color-white: #FFFFFF;\n\n// 浅红\n$light-red: #FFF1F0;\n\n// 浅红背景\n$light-red-bg: #FFF3F4;\n\n// 背景色\n$background-color: #F6F6F6;\n\n// 线条颜色\n$line-color: #F0F0F0;\n\n// 边框颜色\n$border-color: #D9D9D9;\n\n// 文字灰色颜色\n$text-gray-color: #8C8C8C;\n\n// 渐变色\n$linear-gradient: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);\n\n// skin12字体颜色\n$text-skin12: #684aff;\n\n// skin12渐变色\n$linear-gradient-skin12: linear-gradient(1turn, #a18eff, #684aff);\n\n// 占位符颜色\n$placeholder-color: #BFBFBF;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skin6": `skin6_skin6__MzRJG`,
	"header": `skin6_header__97OBl`,
	"logoBox": `skin6_logoBox__SfXgz`,
	"logo": `skin6_logo__fBf0X`,
	"logoBoxRight": `skin6_logoBoxRight__wt0MM`,
	"logoText": `skin6_logoText__e8uwb`,
	"youqianLogoText": `skin6_youqianLogoText__Mhwpv`,
	"logoText2": `skin6_logoText2__bTNBa`,
	"logoText3": `skin6_logoText3__wEWQb`,
	"headTitps": `skin6_headTitps__4Lv0e`,
	"main": `skin6_main__4c5AK`,
	"limitTitle": `skin6_limitTitle__Yh2gm`,
	"limitNum": `skin6_limitNum__FKb9g`,
	"limitTips": `skin6_limitTips__RJPqE`,
	"formBox": `skin6_formBox__YVzbP`,
	"phoneBox": `skin6_phoneBox__hCcAQ`,
	"label": `skin6_label__s91jE`,
	"getCms": `skin6_getCms__qPj46`,
	"agreement": `skin6_agreement__lJxcy`,
	"primary": `skin6_primary__tQLAr`,
	"animation": `skin6_animation__pbHLq`,
	"shake": `skin6_shake__uSP0f`,
	"checked": `skin6_checked__+oIjf`,
	"active": `skin6_active__6J3kc`,
	"footerBar": `skin6_footerBar__iWiSm`,
	"footerBarImg": `skin6_footerBarImg__5oYVH`,
	"steps": `skin6_steps__4+bjh`,
	"stepItem": `skin6_stepItem__wqvdR`,
	"stepNum": `skin6_stepNum__jlznr`,
	"stepName": `skin6_stepName__5xq3T`,
	"splitLine": `skin6_splitLine__nhQRG`,
	"checkBox": `skin6_checkBox__v2ign`,
	"title": `skin6_title__CTVe4`,
	"loanTermList": `skin6_loanTermList__xLvmY`,
	"loanTermItem": `skin6_loanTermItem__tN58f`,
	"samllText": `skin6_samllText__PLtkC`,
	"is360Channel": `skin6_is360Channel__+9IgH`,
	"tipBox": `skin6_tipBox__1D7xG`,
	"tip": `skin6_tip__ROddc`,
	"dialogOverlay": `skin6_dialogOverlay__uUFzD`,
	"showPopup": `skin6_showPopup__cboCg`,
	"dialogMain": `skin6_dialogMain__AL7X9`,
	"close": `skin6_close__cn4hA`,
	"inputBox": `skin6_inputBox__OE2ia`,
	"code": `skin6_code__2YfOr`,
	"limit": `skin6_limit__y5QX7`,
	"rotate": `skin6_rotate__12b8U`
};
export default ___CSS_LOADER_EXPORT___;
